export default __webpack_public_path__ + "static/media/kd.d18e4c28.svg";